import { Report58Container } from "../../../containers/SupportSystem/Reports/Report58Container";
export function Report58Page() {
    return (
        <Report58Container />
    );

}